/* Jess Dinner's — interactions légères (menu mobile, header, apparitions, formulaire de devis). */
(function () {
  'use strict';
  var root = document.documentElement;
  window.jdReady = true;

  /* ---------- Header : ombre au défilement + hauteur mesurée ---------- */
  var header = document.querySelector('[data-jd-header]');
  if (header) {
    var setHeight = function () {
      document.body.style.setProperty('--header-height', header.offsetHeight + 'px');
      document.body.style.setProperty('--header-group-height', header.offsetHeight + 'px');
    };
    setHeight();
    window.addEventListener('resize', setHeight, { passive: true });
    /* Horizon fait défiler .page-wrapper sur ordinateur, la fenêtre sur mobile : on écoute les deux. */
    var scroller = document.querySelector('.page-wrapper');
    var onScroll = function () {
      var y = Math.max(window.scrollY, scroller ? scroller.scrollTop : 0);
      header.classList.toggle('is-scrolled', y > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Menu mobile ---------- */
  var toggle = document.querySelector('[data-jd-menu-toggle]');
  var drawer = document.querySelector('[data-jd-drawer]');
  if (toggle && drawer) {
    var open = function () {
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Fermer le menu');
      root.classList.add('jd-lock');
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    };
    var close = function (returnFocus) {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Ouvrir le menu');
      root.classList.remove('jd-lock');
      if (returnFocus) toggle.focus();
    };
    toggle.addEventListener('click', function () { drawer.hidden ? open() : close(false); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(true); });
    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { close(true); return; }
      if (e.key === 'Tab') {
        var f = [toggle].concat(Array.prototype.slice.call(drawer.querySelectorAll('a, button')));
        var i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
      }
    });
    window.matchMedia('(min-width: 1100px)').addEventListener('change', function (m) { if (m.matches) close(false); });
  }

  /* Sous-menus desktop : un seul ouvert, fermeture au clic extérieur */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.jd-nav__details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- Apparitions au défilement ---------- */
  var items = document.querySelectorAll('[data-jd-reveal]');
  if (root.classList.contains('jd-anim') && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Formulaire de devis ---------- */
  var msg = document.querySelector('[data-jd-focus]');
  if (msg) { msg.scrollIntoView({ block: 'center' }); msg.focus({ preventScroll: true }); }

  var form = document.querySelector('[data-jd-quote]');
  if (form) {
    /* Pré-cocher une prestation via ?prestation=mariage */
    var p = new URLSearchParams(window.location.search).get('prestation');
    if (p) {
      var box = form.querySelector('[data-jd-service="' + p.toLowerCase().replace(/[^a-z0-9-]/g, '') + '"]');
      if (box) box.checked = true;
    }
    /* Pas de date passée */
    var date = form.querySelector('input[type="date"]');
    if (date) date.min = new Date().toISOString().slice(0, 10);
  }
})();
